// Pixel-Accurate Sky TV Clone (Improved UI Fixes)
// React + Tailwind + Custom CSS + Real Slider

import React, { useRef } from "react";

const sectionData = [
  {
    title: "Best of TV",
    items:[ {
      img: `https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt1f65f50df3b4f515/69a99ef7bcbb5cc76294c092/SkyAtlantic_3.png?format=webp&imageManager=true&impolicy=resize&height=592`,
      title: "Show ",
    },
    {
      img: `https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/bltcf1a1d97d5ce3d06/69c69a32b70bd9a0308bb421/AKOTSK.png?format=webp&imageManager=true&impolicy=resize&height=592`,
      title: "Show ",
    },
    {
      img: `https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt3c519c54f09c5920/69c69a407e9d07e08928322e/IT_Welcome_To_Derry.png?format=webp&imageManager=true&impolicy=resize&height=592`,
      title: "Show ",
    },
     {
      img: `https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt15019cc199b35ca3/69b3273ae88d47350b7eb64b/SkyAtlantic_5.png?format=webp&imageManager=true&impolicy=resize&height=592`,
      title: "Show ",
    }, {
      img: `https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt117b605e14ab0770/67d987c61c40c5c347b219e1/2025_Q1_March_W14_Sky_Atlantic_Card_2_Day_of_the_Jackal_V1.png?format=webp&imageManager=true&impolicy=resize&height=592`,
      title: "Show ",
    }
    , {
      img: `https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt1f65f50df3b4f515/69a99ef7bcbb5cc76294c092/SkyAtlantic_3.png?format=webp&imageManager=true&impolicy=resize&height=592`,
      title: "Show ",
    }

    ]
  },
  
  {
    title: "Live on Sky",
    items: Array.from({ length: 10 }).map((_, i) => ({
      img: `https://picsum.photos/300/450?random=${i + 20}`,
      title: "Live " + (i + 1),
    })),
  },
];

function Navbar() {
  return (
    <div className="flex justify-between items-center px-6 py-4 bg-white border-b">
      <h1 className="text-red-500 font-bold text-xl">sky</h1>
      <div className="flex gap-4 items-center">
        <button className="text-sm text-black">Help</button>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-md shadow-sm">
          Sign in
        </button>
      </div>
    </div>
  );
}

function Hero() {
  return (
   <div className="px-4 sm:px-6 py-10 bg-white text-center flex flex-col items-center">
  {/* Heading */}
  <div className="py-36">
  <h1 className="text-3xl sm:text-5xl font-bold text-black max-w-2xl leading-tight">
    What to watch on Sky TV
  </h1>

  {/* Description */}
  <p className="text-gray-600 mt-3 max-w-xl text-sm sm:text-base">
    Discover exclusive and original TV series, blockbuster movies, live sports and more. Customise your package to suit you.
  </p>

  {/* Button */}
  <button className="mt-6 bg-green-600 hover:bg-green-700 transition-all duration-300 text-white px-6 py-3 rounded-md shadow-md hover:shadow-lg">
    Get Sky TV
  </button>
  </div>

  {/* Image Section */}
  <div className="mt-8 relative w-full max-w-5xl rounded-2xl overflow-hidden shadow-lg">
    <img
      src="https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/bltbeca4b5da468af3b/69baee07f64ab411bbbe1da9/SNL_UK_TEASE-HL.jpg?imageManager=true&impolicy=resize&width=1600"
      className="w-full h-[220px] sm:h-[300px] md:h-[450px] object-cover"
      alt="Featured"
    />

 
  </div>
</div>
  );
}

function SliderRow({ title, items }) {
  const ref = useRef();

  const scroll = (dir) => {
    const width = ref.current.offsetWidth;
    ref.current.scrollBy({ left: dir * width * 0.8, behavior: "smooth" });
  };

  return (
    <div className="px-28 mt-10 bg-white">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-semibold text-black">{title}</h2>
        <button className="text-blue-600 text-sm">Learn more</button>
      </div>

      <div className="relative">
        <button
          onClick={() => scroll(-1)}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md p-2 rounded-full"
        >
          ◀
        </button>

        <div
          ref={ref}
          className="flex gap-4 overflow-x-auto scroll-smooth no-scrollbar"
        >
          {items.map((item, i) => (
            <div
              key={i}
              className="min-w-[160px] md:min-w-[200px] group"
            >
              <div className="relative shadow-md rounded-lg">
                <img
                  src={item.img}
                  className="rounded-lg w-full h-[240px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition" />
              </div>
              <p className="text-sm mt-1 text-black">{item.title}</p>
            </div>
          ))}
        </div>

        <button
          onClick={() => scroll(1)}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md p-2 rounded-full"
        >
          ▶
        </button>
      </div>
    </div>
  );
}

function Banner({ img }) {
  return (
    <div className="px-6 mt-12 bg-white">
      <img src={img} className="rounded-xl w-full shadow" />
    </div>
  );
}

function Anticipated() {
  return (
    <div className="px-24 mt-14 bg-white">
      <h2 className="text-xl font-bold mb-4 text-black">
        This month’s most anticipated releases
      </h2>

      <div className="grid md:grid-cols-3 gap-4">
        <div className="md:col-span-2">
          <img
            src="https://picsum.photos/800/400"
            className="rounded-xl w-full shadow"
          />
        </div>
        <div className="space-y-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex gap-3 items-center">
              <img
                src={`https://picsum.photos/100/70?${i}`}
                className="rounded shadow"
              />
              <p className="text-sm text-black">Release {i + 1}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function WatchSky() {
  return (
    <div className="px-24 mt-14 grid md:grid-cols-3 gap-6 bg-white">
      {["Sky Go", "Sky Glass", "Sky Stream"].map((item, i) => (
        <div key={i} className="bg-white rounded-xl p-6 shadow-md">
          <h3 className="font-semibold text-lg mb-2 text-black">{item}</h3>
          <img
            src={`https://picsum.photos/300/200?device=${i}`}
            className="rounded"
          />
          <button className="mt-4 border px-4 py-2 rounded text-green-600 border-green-600 hover:bg-green-600 hover:text-white transition">
            Learn more
          </button>
        </div>
      ))}
    </div>
  );
}


export default function Watch() {
  return (
    <div className="bg-white min-h-screen">
      {/* <Navbar /> */}
      <Hero />

      {sectionData.map((sec, i) => (
        <SliderRow key={i} title={sec.title} items={sec.items} />
      ))}

      <Banner img="https://picsum.photos/1200/300?banner" />
      <SliderRow title="Cinema" items={sectionData[0].items} />
      <Banner img="https://picsum.photos/1200/400?superman" />
      <SliderRow title="Kids" items={sectionData[1].items} />

      <Anticipated />
      <WatchSky />
      <section className="py-14 md:py-20 px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
          FAQs
        </h2>

        <div className="space-y-3">
          
          <details className="group border border-gray-200 rounded-xl p-4 md:p-5 bg-white hover:shadow-sm transition">
            <summary className="cursor-pointer flex justify-between items-center font-medium text-sm md:text-base list-none">
              What is included in Sky Deals?
              <span className="text-gray-400 group-open:rotate-45 transition">+</span>
            </summary>
            <p className="text-gray-600 text-sm md:text-base mt-3 leading-relaxed">
              Sky Deals includes access to Sky TV, Netflix, Disney+, HBO Max, and Hayu.
            </p>
          </details>

          <details className="group border border-gray-200 rounded-xl p-4 md:p-5 bg-white hover:shadow-sm transition">
            <summary className="cursor-pointer flex justify-between items-center font-medium text-sm md:text-base list-none">
              Can I cancel anytime?
              <span className="text-gray-400 group-open:rotate-45 transition">+</span>
            </summary>
            <p className="text-gray-600 text-sm md:text-base mt-3 leading-relaxed">
              Yes, you can cancel your subscription at any time.
            </p>
          </details>

          <details className="group border border-gray-200 rounded-xl p-4 md:p-5 bg-white hover:shadow-sm transition">
            <summary className="cursor-pointer flex justify-between items-center font-medium text-sm md:text-base list-none">
              Do you offer HD or 4K?
              <span className="text-gray-400 group-open:rotate-45 transition">+</span>
            </summary>
            <p className="text-gray-600 text-sm md:text-base mt-3 leading-relaxed">
              Yes, we offer HD and 4K streaming depending on your plan.
            </p>
          </details>

          <details className="group border border-gray-200 rounded-xl p-4 md:p-5 bg-white hover:shadow-sm transition">
            <summary className="cursor-pointer flex justify-between items-center font-medium text-sm md:text-base list-none">
              Is this available worldwide?
              <span className="text-gray-400 group-open:rotate-45 transition">+</span>
            </summary>
            <p className="text-gray-600 text-sm md:text-base mt-3 leading-relaxed">
              Availability may vary depending on your region.
            </p>
          </details>

        </div>
      </section>
    </div>
  );
}

// Add this to your global CSS (important for hiding scrollbar):
// .no-scrollbar::-webkit-scrollbar { display: none; }
// .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
